export const api = {
  cwIncomeStatement: '/bonus-statement',
  yearlyIncomeReport: '/yearly-income-report',
  stockistCommission: '/stockist-commission',
  cwBonusReport: '/cw-bonus-report',
  memberBonusManualAdjustment: '/member-bonus-manual-adjustment',
  downloadManualAdjustmentTemplate: '/download-manual-adjustment-template',
  uploadManualAdjustmentTemplate: '/upload-manual-adjustment-template',
}
